import React, { useEffect, useState } from 'react';
import { Spin, Modal } from 'antd';
import classNames from 'classnames';
import { LoadingOutlined } from '@ant-design/icons';

import styles from './loader.module.scss';

interface ILoaderProps {
	loading?: boolean;
	modal?: boolean; // show loader in a Modal
	showSimpleSpinner?: boolean; // option to show old antd loader
	text?: string;
	bgColor?: string;
}

const LONG_WAIT_DURATION = 5000; // 5 seconds

export function Loading(props: ILoaderProps) {
	const { loading = false, modal = false, showSimpleSpinner = false, text = '', bgColor } = props;
	const [longWait, setLongWait] = useState(false);
	const icon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

	// update text to "This may take a while..." if loading variable is not update to false for more than 5 seconds
	useEffect(
		function handleLongWaitTimeout() {
			let timeOutId: any | null = null;

			if (loading) {
				timeOutId = setTimeout(() => {
					if (loading) {
						setLongWait(true);
					}
				}, LONG_WAIT_DURATION);
			} else {
				setLongWait(false);
			}

			// cleanup: reset long wait, clear timeout
			return () => {
				clearTimeout(timeOutId);
				setLongWait(false);
			};
		},
		[loading]
	);

	const elm = (
		<div
			className={classNames({
				[styles.indicator]: true,
				[styles.loading]: loading
			})}
		>
			{showSimpleSpinner ? <Spin indicator={icon} /> : <BlinkLoader bgColor={bgColor} />}
			{text && <p>{text}</p>}
			{longWait && <p>Good things take time! We appreciate your patience...</p>}
		</div>
	);
	if (!loading) {
		return null;
	}
	if (modal) {
		return (
			<Modal
				open={loading}
				style={{
					maxWidth: '100%',
					maxHeight: '100%',
					top: '50%'
				}}
			>
				{elm}
			</Modal>
		);
	} else {
		return elm;
	}
}

function BlinkLoader(props: { bgColor?: string }) {
	console.log(props.bgColor);
	const loaderStyle = { backgroundColor: props.bgColor ?? '#1890ff' };
	return (
		<div className={styles.loader}>
			<div
				className={classNames({
					[styles.loaderCircle]: true,
					[styles.delay1]: true
				})}
				style={loaderStyle}
			/>
			<div
				className={classNames({
					[styles.loaderCircle]: true,
					[styles.delay2]: true
				})}
				style={loaderStyle}
			/>
			<div
				className={classNames({
					[styles.loaderCircle]: true,
					[styles.delay3]: true
				})}
				style={loaderStyle}
			/>
			{/* This is just for spacing in the original example */}
			<div style={{ position: 'absolute', left: '80px', width: '0', height: '0' }} />
		</div>
	);
}
